import React, { useEffect, useState } from "react";
import api, { formatApiError } from "@/lib/api";
import { PageHead, Loading, Pill } from "@/components/common";
import { toast } from "sonner";

export default function Settings() {
  const [s, setS] = useState(null);
  useEffect(() => { api.get("/settings").then((r) => setS(r.data)); }, []);

  const save = async () => {
    try {
      const body = { ...s }; delete body.id;
      await api.patch("/settings", body);
      toast.success("Settings saved");
    } catch (e) { toast.error(formatApiError(e.response?.data?.detail)); }
  };
  if (!s) return <Loading />;

  const Field = ({ label, k, type = "text", suffix }) => (
    <div>
      <label className="text-xs font-semibold text-slate-600">{label}</label>
      <div className="flex items-center gap-2 mt-1">
        <input type={type} value={s[k] ?? ""} onChange={(e) => setS({ ...s, [k]: type === "number" ? parseInt(e.target.value || 0) : e.target.value })} className="w-full px-3 py-2 rounded-lg border border-slate-200 text-sm" />
        {suffix && <span className="text-xs text-slate-400">{suffix}</span>}
      </div>
    </div>
  );

  return (
    <div>
      <PageHead overline="Settings & Integrations" title="Settings" desc="Wallet policy, redemption limits and provider status. Unconfigured live actions stay visibly unavailable." />
      <div className="grid lg:grid-cols-2 gap-6">
        <div className="bg-white rounded-xl border border-slate-200 p-5 space-y-4">
          <h3 className="font-semibold text-slate-800 font-head">Program & Wallet</h3>
          <Field label="Client label" k="client_label" />
          <Field label="Points → paise (₹ value)" k="points_to_paise" type="number" suffix="paise / point" />
          <Field label="Minimum redemption (points)" k="min_redeem_points" type="number" />
          <Field label="Maximum redemption (points)" k="max_redeem_points" type="number" />
          <Field label="Daily redeem cap (points)" k="daily_redeem_cap_points" type="number" />
          <label className="flex items-center justify-between text-sm"><span>Pooled cross-brand redemption</span><button data-testid="pooled-toggle" onClick={() => setS({ ...s, pooled_redemption: !s.pooled_redemption })}><Pill status={s.pooled_redemption ? "active" : "inactive"}>{s.pooled_redemption ? "Enabled" : "Disabled (default)"}</Pill></button></label>
          <label className="flex items-center justify-between text-sm"><span>Points expiry</span><button onClick={() => setS({ ...s, expiry_enabled: !s.expiry_enabled })}><Pill status={s.expiry_enabled ? "active" : "inactive"}>{s.expiry_enabled ? "Enabled" : "Disabled"}</Pill></button></label>
          <button data-testid="settings-save-btn" onClick={save} className="w-full tnp-gradient text-white font-semibold py-2.5 rounded-lg">Save settings</button>
        </div>
        <div className="bg-white rounded-xl border border-slate-200 p-5 space-y-4">
          <h3 className="font-semibold text-slate-800 font-head">Provider Integrations</h3>
          {[["WhatsApp Business API", "whatsapp_status"], ["SMS Gateway", "sms_status"], ["RCS", "rcs_status"], ["UPI Payout Partner", "payout_status"]].map(([l, k]) => (
            <div key={k} className="flex items-center justify-between border border-slate-100 rounded-lg px-3 py-2.5">
              <span className="text-sm text-slate-700">{l}</span>
              <span className={`text-xs font-semibold px-2 py-1 rounded-full ${s[k] === "configured" ? "bg-emerald-50 text-emerald-700" : "bg-amber-50 text-amber-700"}`}>{s[k] === "configured" ? "Configured" : s[k] === "sandbox" ? "Sandbox" : "Not configured"}</span>
            </div>
          ))}
          <Field label="Shared WhatsApp number" k="whatsapp_number" />
          <div className="text-xs text-slate-400 bg-slate-50 rounded-lg p-3">Live sends & real payouts require authorized production credentials. Secrets are stored in environment variables, never in code. Timezone: {s.timezone}.</div>
        </div>
      </div>
    </div>
  );
}
